import React, { useState } from 'react'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

const AlertDialog = ({title, message, handleClose, noBackdropClick = false}) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const [dlgOpen, setDlgOpen] = useState(true);
	
	const closeDialog = (event, reason) => {
		if(noBackdropClick && reason !== 'clickedOk'){
			return;
		}
		setDlgOpen(false);
		handleClose();
	}
	
	return (
		<Dialog
			open={dlgOpen}
			onClose={(event, reason) => closeDialog(event, reason)}
			fullScreen={!isSm}
			aria-labelledby="cart-dialog-title"
			className={classes.settingsDialog}
			>
			<DialogTitle id="cart-dialog-title">{title}</DialogTitle>
			<DialogContent dividers>
			<Typography paragraph>{message}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => closeDialog(null, 'clickedOk')} color="primary" variant="contained">
				OK
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AlertDialog